import classes from './RowGroup.module.css';
import classNames from 'classnames';
import * as React from 'react';
import { COLLAPSED_ROW_HEIGHT } from '../../layout';
import { useSolutions, useRowHeights, useTasksBySolution } from '../../state/context';

const SolutionSidebarRows = () => {
  const solutions = useSolutions();
  const tasks = useTasksBySolution();
  const rowHeights = useRowHeights();

  return (
    <>
      {solutions.map((solution) => (
        <div
          key={solution.id}
          style={{
            height: rowHeights[solution.id] || COLLAPSED_ROW_HEIGHT,
          }}
          className={classNames(
            classes.rowGroup,
            'flex flex-col items-center justify-center transition-height'
          )}
        >
          <h3 className="text-xxs uppercase font-bold">{solution.name}</h3>
          <div className="w-6 border-b border-black mt-1 mb-3" />
          <div className="text-4xl font-light">{tasks[`${solution.id}`]?.length || 0}</div>
          <div className="text-xxxs uppercase font-bold mt-px">sager</div>
          <div className="text-xxxs uppercase">I alt over hele perioden</div>
        </div>
      ))}
    </>
  );
};

export default SolutionSidebarRows;
